import { render, staticRenderFns } from "./CrmTypeSelectList.vue?vue&type=template&id=c062bb38&scoped=true&"
import script from "./CrmTypeSelectList.vue?vue&type=script&lang=ts&"
export * from "./CrmTypeSelectList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c062bb38",
  null
  
)

export default component.exports